import swal from 'sweetalert2'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import type { TrackingLinkModel } from '@domain-group/realhub-backend-api-types'

import useTrackingLink from '@hooks/useTrackingLink'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

const confirmDelete = (
  deleteTrackingLink: (payload: HandleCallbackActionParams) => void,
  deleteFn: HandleCallbackActionParams['callbacks']['action'],
) => {
  const deleteTrackingLinkPayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Link Deleted',
  }

  swal
    .fire({
      title: 'Delete Link?',
      text: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it.',
      confirmButtonColor: '#DD6B55',
    })
    .then(({ value }) => {
      if (value){
        deleteTrackingLink(deleteTrackingLinkPayload)
      }
    })
}

interface TrackingLinkProps {
  callbacks: {
    deleteTrackingLink: () => void,
  },
  trackingLink: TrackingLinkModel,
}

const TrackingLink = (props: TrackingLinkProps) => {
  const {
    callbacks: { deleteTrackingLink },
    trackingLink,
    trackingLink: { title, url },
  } = props

  const trackingLinkPayload = useTrackingLink(trackingLink)

  const {
    callbacks: {
      createOrEditTrackingLink,
      deleteTrackingLink: deleteFn,
    },
  } = trackingLinkPayload

  return (
    <DashboardModuleListItem boxProps={{ paddingY: 'medium' }} title={title}>
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => createOrEditTrackingLink()}
          type="edit"
        />

        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => confirmDelete(deleteTrackingLink, deleteFn)}
          type="delete"
        />

        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          href={url}
          marginRight="medium"
          target="_blank"
          type="link"
        />
      {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default TrackingLink
